import React from 'react';
import { pushModal, popModal } from 'Scripts/actions';

export function UserProfile() {

	const showPasswordModal = () => {
		pushModal({
			component: <div className='alert'>
				<section>
					<header><span>Change Password</span></header>
					<div className='alerts'>
						{/* Error message to display if current password is incorrect */}
						<section className='alert error'><span>Current password is incorrect. Please try again.</span></section>
					</div>
					<div className='content'>
						<input type='password' placeholder='Enter current password' autoCapitalize='' autoCorrect='off' value=''></input>
						<input type='password' placeholder='Enter new password' autoCapitalize='' autoCorrect='off' value=''></input>
						<div className='actions'>
							<button onClick={popModal}><span>Cancel</span></button>
							{/* Append class .disabled to the .action button below until the user has entered values in both text inputs above */}
							<button className='action'><span>Save</span></button>
						</div>
					</div>
				</section>
			</div>
		})
	}

	{/* This template is based on, and shares data/layout with, the existing employeeEdit.tsx */}
	return <section className='systemAdmin'>
		<section>
			<div>
				<table className='half' cellPadding='0' cellSpacing='0'>
					<tbody>
						<tr className=''>
							<td></td>
							<td><strong>First Name</strong></td>
							<td><span className='readOnly'>Pam</span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Last Name</strong></td>
							<td><span className='readOnly'>Beesly</span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Job Title</strong></td>
							<td><span className='readOnly'>Design Consultant</span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Department</strong></td>
							<td><span className='readOnly'>Retail Sales</span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Email Address</strong></td>
							<td><span className='readOnly'>pbeesly@legacykitchens.com</span></td>
							<td></td>
						</tr>
					</tbody>
				</table>
				<table className='half' cellPadding='0' cellSpacing='0'>
					<tbody>
						<tr className=''>
							<td></td>
							<td><strong>Profile Photo</strong></td>
							<td>
								{/* Update the Avatar class in sharedComponents.tsx per below */}
								<div className='userPhotoControl'>
									<div className='userPhoto add'></div>
									<input type='file' accept='image/*' capture='user'></input>
									{/* Edit button should only be visible when userPhotoControl is in a table. Currently, the style sheet makes this determination. */}
									<a href=''>Edit</a>
									{/* Remove button should only be only shown when userPhotoControl is in a table. This logic will need to be handled by the script */}
									<a href='' className='remove'>Remove</a>
								</div>
							</td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>User Name</strong></td>
							<td><span className='readOnly'>Pam.Beesly</span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Password</strong></td>
							<td><span className='readOnly'><a onClick={showPasswordModal}>Change Password</a></span></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><strong>Office Phone</strong></td>
							<td><input type='text' placeholder='' autoCapitalize='' autoCorrect='off' value='4039307097'></input></td>
							<td></td>
						</tr>
						<tr className=''>
							<td></td>
							<td><select className='label'>
								<option value='4'>Mobile Phone</option>
								<option value='1'>Home Phone</option>
							</select>
							</td>
							<td><input type='text' placeholder='' autoCapitalize='' autoCorrect='off' value=''></input></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>

	</section>;
}